import { Component, Input, Output, EventEmitter, OnInit, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicComponent, HisNotificationService, HisUiService, HisGenericValueService,
    HisBaseGlobalsService, HisNavigationService } from 'hisng';

import { SEARCH_CONFIG_MINI_PUBLICATION } from 'app/fs/res/common/model/searchConstants';
import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { PublicationService } from 'app/fs/res/publication/service/publication.service';
import { Publication, SimplePublication } from 'app/fs/res/publication/model/publication';

@Component({
    selector: 'res-publication-panel',
    templateUrl: './publication-panel.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationPanelComponent)],
})
export class PublicationPanelComponent implements OnInit {
    @Input() dDKey: string;
    @Input() selectedPublications: Publication[] = [];
    @Input() isOptional: boolean;
    @Input() editMode = true;
    @Input() selectedPublication: SimplePublication;
    @Input() dynamicComponent: DynamicComponent;
    @Input() infoMessage: string;
    @ViewChildren(DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef }) fieldViewContainerList: QueryList<ViewContainerRef>;

    @Output() selectedPublicationsChange = new EventEmitter<Publication[]>();
    @Output() routerContextChange = new EventEmitter();
    @Output() tabIndexChanged = new EventEmitter();

    readonly SEARCH_CONFIG_MINI_PUBLICATION = SEARCH_CONFIG_MINI_PUBLICATION;

    showPubViewBtn = false;

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private genericValueService: HisGenericValueService,
        private hisBaseGlobalsService: HisBaseGlobalsService,
        private navigationService: HisNavigationService,
        private publicationService: PublicationService ) {
    }

    ngOnInit() {
        this.dDKey = this.dDKey ? this.dDKey : 'fs.res.common.publications';
        this.showPubViewBtn = this.hisBaseGlobalsService.isAnyModuleActive('HISINONERES');
    }

    /**
     * get assigned publications for project
     */
    getSelectedPublications(): Publication[] {
        return this.selectedPublications;
    }

    onSelectBySearchPopup(event: any[]) {
        if (!event || event.length === 0) {
            // the selected list has been emptied
            this.selectedPublications = [];
            this.selectedPublicationsChange.emit(this.selectedPublications);
        } else {
            // convert search result into Publication[]
            let publicationIds: number[] = event.map(searchResultRow => parseInt(searchResultRow.id, 10));
            this.publicationService.getPublicationsByIds(publicationIds).subscribe( (publications: Publication[]) => {
                this.selectedPublications = publications;
                this.selectedPublicationsChange.emit(this.selectedPublications);
            });
        }
    }

    onSelectByAutocomplete() {
        if (!this.selectedPublication) {
            this.notificationService.errorI18nRes('fs.res.common.error.publication');
        } else {
            let containedPublication =
                this.genericValueService.findRowByValue(this.selectedPublications, this.selectedPublication.id);
            if (!containedPublication) {
                this.publicationService.getPublicationById(this.selectedPublication.id).subscribe( (p: Publication) => {
                    this.selectedPublications = [...this.selectedPublications, p];
                    this.selectedPublicationsChange.emit(this.selectedPublications);
                    this.selectedPublication = undefined;
                });
            } else {
                this.notificationService.warn(
                    this.hisUiService.translate(
                        'fs.res.common.warning.publicationAlreadyAssigned', '"' + containedPublication.title + '"'),
                    this.hisUiService.translate('fs.res.common.service.warn')
                );
            }
        }
    }

    /**
     * remove publication with given index
     *
     * @param publication publication to remove.
     */
    removePublication(publication: Publication) {
        const index = this.selectedPublications.indexOf(publication);
        this.selectedPublications = this.genericValueService.deleteRow(this.selectedPublications, index);
        this.selectedPublicationsChange.emit(this.selectedPublications);
    }

    /* navigation to publications detail-view */
    onBeforeNavigate() {
        this.navigationService.setLastBackUrl(window.location.href);
        // emit routerContextChange to save current ngModel in globalDataService
        this.routerContextChange.emit();
    }
}
